import axios from 'axios';
import Cookies from 'cookies-js';
import hitchApi from './hitchEndPointBase';

const parseResponse = (response) => {
  if (!response.ok) {
    return response.json().then((json) => {
      if (json.error) throw new Error(JSON.stringify(json));
    });
  }
  return response.text().then((text) => {
    try {
      return {
        statusCode: response.status,
        data: JSON.parse(text),
      };
    } catch (e) {
      return {
        statusCode: response.status,
        data: { text },
      };
    }
  });
};

/**
 * Pull a human-readable reason out of a rejected axios error.
 *
 * Nest puts the useful text in `message` and a generic label in `error`
 * ("Bad Request", "Forbidden"), so `message` has to win — reading `error`
 * first is why deliberate refusals used to surface as "Bad Request".
 * `ValidationPipe` returns `message` as an array of field errors. Legacy
 * (non-Nest) services send only `error`, which the second branch still covers.
 *
 * Every access is optional-chained on purpose: a 400 with an empty or HTML body
 * has `response` but no `data`, so `response.data.error` would throw.
 *
 * Returns undefined when there is nothing useful, so callers can `||` in their
 * own fallback copy.
 */
export const apiErrorMessage = (error) => {
  const data = error?.response?.data;
  const message = Array.isArray(data?.message) ? data.message.join(', ') : data?.message;
  return message || data?.error || error?.message;
};

export const get = (endpoint) =>
  axios.get(`${hitchApi}${endpoint}`, { headers: { Authorization: Cookies.get('user') } });
export const post = (endpoint, data = {}) =>
  axios.post(`${hitchApi}${endpoint}`, data, { headers: { Authorization: Cookies.get('user') } });
export const put = (endpoint, data = {}) =>
  axios.put(`${hitchApi}${endpoint}`, data, { headers: { Authorization: Cookies.get('user') } });
export const patch = (endpoint, data = {}) =>
  axios.patch(`${hitchApi}${endpoint}`, data, { headers: { Authorization: Cookies.get('user') } });
export const del = (endpoint) =>
  axios.delete(`${hitchApi}${endpoint}`, { headers: { Authorization: Cookies.get('user') } });

// function to mock api calls
export default function mockApiCalls(data, delay = 500) {
  new Promise((resolve) =>
    setTimeout(
      () =>
        resolve(
          parseResponse({
            status: 200,
            statusText: 'Success',
            data,
            text: () => Promise.resolve(JSON.stringify(data)),
            url: '',
            ok: true,
            json: () => Promise.resolve(data),
            headers: {},
          }),
        ),
      delay,
    ),
  );
}
